module.exports = __webpack_public_path__ + "static/media/mill_10.9ad7f97d.jpg";